import { render } from "./PlayerCard.vue?vue&type=template&id=7e95d63f&scoped=true"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"

import "./PlayerCard.vue?vue&type=style&index=0&id=7e95d63f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e95d63f"]])

export default __exports__